import { render, staticRenderFns } from "./IcoContentSkill.vue?vue&type=template&id=60820a42"
import script from "./IcoContentSkill.vue?vue&type=script&lang=js"
export * from "./IcoContentSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports